import Vue from 'vue'
import 'es6-promise/auto' // プロミスをポリフィルする
import App from './App'
import ErrorBoundary from './ErrorBoundary.vue' // エラーを捕捉するコンポーネント
import router from './router'
import store from './store' // Vuexのストアインスタンスをインポート
import session from './utils/session'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../plugins/font-awesome/css/font-awesome.min.css'
import 'vue-ionicons/ionicons.css'

import '../plugins/iCheck/all.css'

import '../plugins/datatables/dataTables.bootstrap4.css'
import '../lib/css/adminlte.min.css'
import '../lib/css/googleapis.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'
import Toasted from 'vue-toasted'
import VueWait from 'vue-wait'

Vue.use(Toasted)
Vue.use(VueWait)
Vue.use(Vuelidate)
Vue.use(VueLazyload)
Vue.prototype.$API_URL = window.API_URL
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.config.performance = true // NODE_ENV == 'development'で測定有効化
Vue.use(ElementUI)
// ErrorBoundaryコンポーネントのインストール
Vue.component(ErrorBoundary.name, ErrorBoundary)

Vue.config.errorHandler = (err, vm, info) => {
  console.error('errorHandler err:', err)
  console.error('errorHandler vm:', vm)
  console.error('errorHandler info:', info)
}

Vue.mixin(session)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  wait: new VueWait(),
  router,
  store, // インポートしたストアインスタンスを`store`オプションとして指定
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js